import React from 'react'
import { AppBar, Toolbar } from '@material-ui/core'
import { pointrLogoFull } from '../../assets/images'
import useEnterpriseAppBarStyles from './Styles'
import { IEnterpriseAppBarProps } from './Interfaces'

const EnterpriseAppBar: React.FC<IEnterpriseAppBarProps> = ({ enterpriseLogo }) => {
  const classes = useEnterpriseAppBarStyles({})
  return (
    <AppBar
      position="relative"
      classes={{
        root: classes.appBarRoot
      }}
    >
      <Toolbar classes={{ root: classes.toolbarRoot }}>
        <a href="/">
          <img id={'pointr-logo'} src={pointrLogoFull} alt="Pointr" />
        </a>

        {enterpriseLogo && (
          <a href="/">
            <img className={classes.enterpriseLogo} id={'enterprise-logo'} src={enterpriseLogo} alt="Enterprise" />
          </a>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default React.memo(EnterpriseAppBar)
